import React from 'react';
import { IAlertPanel } from './types';
import style from './style.module.scss';
import MuiAlert from '@material-ui/lab/Alert';
import { withStyles, Button } from '@material-ui/core';
import { renderIf } from 'external-services/react-utils-service';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import IconsService from 'external-services/icons-service/icons.service';
import { IconTypes } from 'external-services/icons-service/icons.types';
import { IValidationErrorListItem } from 'external-services/booking-validation-service/bookingValidation.types';

const NS = 'AlertPanel';

const Alert = withStyles({
  icon: {
    alignItems: 'center',
  },
})(MuiAlert);

const formatMsg = (msg: string) => {
  if(!msg) return '';
  return msg.indexOf('\.') > -1 ? msg : msg+ '.';
}

const Icon = IconsService.getIcon(IconTypes.arrowDown);

const AlertLink = (props: {
  data: IValidationErrorListItem;
  handleLinkClick: () => void;
}) => {
  const {
    data,
    handleLinkClick,
  } = props;

  const isClickable = !!handleLinkClick;

  return (
    <div 
      className={classNames({
        [style.warningContainer]: true,
        [style.warningLink]: isClickable,
      })}
    >
      {
        isClickable &&
        <div className={style.alertIcon}><Icon /></div>
      }
      {
        !isClickable && <div dangerouslySetInnerHTML={{ __html: "&bullet;&nbsp;" }}></div>
      }
      <div
        className={classNames({
          [style.alertText]: true,
          [style.link]: isClickable,

        })}
        onClick={handleLinkClick}
      >{formatMsg(data.msg)}</div>
    </div>
  )
}

export default function AlertPanel({
  message,
  buttonText,
  buttonHandler,
  severity,
  customColor,
  messageList,
  handleLinkClick,
}: IAlertPanel) {
  const useStyles = makeStyles({
    customColor: {
      backgroundColor: customColor,
      color: 'black',
    },
  });

  const classes = useStyles();

  const isClickable = !!handleLinkClick;

  return (
    <Alert
      severity={severity || 'error'}
      variant="filled"
      className={classNames({
        [style.root]: true,
        [classes.customColor]: customColor,
      })}
    >
      <span className={style.link} dangerouslySetInnerHTML={{ __html: message }} />
      {
        messageList && messageList.length > 0 && 
        messageList.map((msg: IValidationErrorListItem, index: number) => <AlertLink 
          key={index.toString()}
          data={msg}
          handleLinkClick={isClickable ? () => {
            handleLinkClick(msg);
          } : null}
        />)        
      }
      {renderIf(buttonText && buttonHandler, () => (
        <Button
          className={style.btn}
          variant="contained"
          color="default"
          size="small"
          onClick={buttonHandler}
        >
          {buttonText}
        </Button>
      ))}
    </Alert>
  );
}
